export default "__VITE_ASSET__B6A7jZqf__"